// extracted by mini-css-extract-plugin
export default {"toggle":"Tzf9z","toggle--empty":"aRn1r","toggle--main":"qCdAY","toggle--secondary":"w499d","toggle--opened":"rVCth","toggle--error":"pCr1S"};